<div class="d-flex flex-column gap-3 justify-content-center align-items-center leave-container">
  <div class="w-50 py-4 px-4r">
    <img class="palm-tree" src="assets/images/on-leave/nspace-under-palm-tree.png" [alt]="'LEAVE_PAGE.TITLE' | translate" />
  </div>
  <div class="w-50 px-4r">
    <h1>{{ 'LEAVE_PAGE.TITLE' | translate }}</h1>
    <p class="mb-4">{{ 'LEAVE_PAGE.DESCRIPTION' | translate }}</p>
    <button class="btn btn-primary d-flex" type="button" (click)="onEndLeave()">
      <span>{{ 'LEAVE_PAGE.END_LEAVE_NOW' | translate}}</span>
      <i class="icon ni-outbound color-white ms-2"></i>
    </button>
  </div>
</div>
